<template>
  <div class="login-screen">
    <img v-if="logo" :src="logo" alt="App Logo" class="logo" />
    <h1>Welcome to {{companyName}}</h1>
    <!-- <p>Please login with your CamGen Sky Account</p> -->
    <button @click="login" class="login-button">Log in</button>
    
    <p v-if="error">{{ error }}</p>
  </div>
</template>

<script>
import axios from '@/axios-config';
export default {
  name: 'LoginScreen',  data() {
    return {
      logo: null,
      companyName: null,
    };
  },
  methods: {
    async fetchCompanySettings() {
      try {
        const companyInfoResponse = await axios.get('/api/company-setting/');
        this.companyName = companyInfoResponse.data.company_name; 
        this.logo = companyInfoResponse.data.logo; 
      } catch (err) {
        console.error(err);
      } 
    },
    login() {
      this.$emit('login'); // Emit a login event to the parent component
    }
  },
  created(){
    this.fetchCompanySettings();
  }
};
</script>

<style scoped>
.login-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: white;
  font-family: TT Ramillas Trl, Inter, sans-serif;
}

.logo {
  width: 6rem;
  height: auto;
  margin-bottom: 5px;
}

h1 {
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.login-button {
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: #1E3E59;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: TT Ramillas Trl, Inter, sans-serif;
}

.login-button:hover {
  background-color: #0056b3;
}
</style>

